import React, { useEffect, useState } from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody, Row, Col, Input, Button } from "reactstrap"
import { Map, TileLayer, Polyline, Marker, Popup } from "react-leaflet"
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import {
  FaLocationDot,
  FaLocationPin,
  FaLocationPinLock,
} from "react-icons/fa6"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/Loader"
import { FaRoute } from "react-icons/fa"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"

// ── Custom marker icons ───────────────────────────────────────
const createColoredIcon = color =>
  new L.DivIcon({
    className: "",
    html: `
      <div style="
        width: 28px; height: 28px;
        background: ${color};
        border: 3px solid #fff;
        border-radius: 50% 50% 50% 0;
        transform: rotate(-45deg);
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      "></div>
    `,
    iconSize: [28, 28],
    iconAnchor: [14, 28],
    popupAnchor: [0, -28],
  })

const startIcon = createColoredIcon("#22c55e") // green
const endIcon = createColoredIcon("#EF5350") // red

const LocationTracking = () => {
  const [employee, setEmployee] = useState("")
  const [date, setDate] = useState("")
  const [route, setRoute] = useState([])

  const [loading, setLoading] = useState(false)
  const [employees, setEmployees] = useState([])

  const [data, setData] = useState({})

  useEffect(() => {
    getEmployees()
  }, [])

  async function getEmployees() {
    const APIdata = await fetchData(setLoading, "users")
    if (APIdata?.success) {
      setEmployees(APIdata?.data)
    }
  }

  const fetchLocationData = async () => {
    const APIdata = await FetchPostData(
      setLoading,
      "attendance/user/route/by/date",
      {
        userId: employee,
        date,
      }
    )
    if (APIdata?.data?.success) {
      setData(APIdata?.data?.data)
      setRoute(APIdata?.data?.data?.polyline)
    } else {
      Swal.fire({
        title: "Error fetching Route",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const { checkAccess } = usePermissionData()

  return (
    <PermittedComponent isAccess={checkAccess(7, "view")}>
      <div className="page-content">
        {loading && <Loader />}
        <Breadcrumb
          title="Employee Tracking"
          breadcrumbItem="Location Tracking"
        />

        <Card className="mb-3">
          <CardBody>
            <Row>
              <Col md={2}>
                <Input
                  type="select"
                  className="rounded-4"
                  onChange={e => setEmployee(e.target.value)}
                >
                  <option value="">Select Employee</option>
                  {employees?.map((item, index) => (
                    <option value={item?.id} key={index}>
                      {item?.name}
                    </option>
                  ))}
                </Input>
              </Col>

              <Col md={2}>
                <Input
                  type="date"
                  className="rounded-4"
                  onChange={e => setDate(e.target.value)}
                />
              </Col>

              <Col md={2}>
                <Button
                  className="btn-blue rounded-4 px-3 text-nowrap"
                  block
                  disabled={!employee || !date}
                  onClick={fetchLocationData}
                >
                  <FaRoute /> Track Route
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {route?.length > 0 ? (
          <Card>
            <CardBody style={{ height: "600px" }}>
              <div
                style={{
                  position: "absolute",
                  top: "30px",
                  right: "30px",
                  zIndex: 1000,
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: "12px",
                  padding: "10px 16px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                  border: "1px solid #e2e8f0",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "2px",
                }}
              >
                <span
                  style={{
                    fontSize: "11px",
                    color: "#94a3b8",
                    fontWeight: 600,
                  }}
                >
                  TOTAL DISTANCE
                </span>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: 800,
                    color: "#1e293b",
                  }}
                >
                  {data?.distance?.km} km
                </span>
              </div>
              <Map
                center={route[0]}
                zoom={14}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <Polyline positions={route} color="blue" />

                <Marker position={route[0]} icon={startIcon}>
                  <Popup>Start Location</Popup>
                </Marker>

                <Marker position={route[route.length - 1]} icon={endIcon}>
                  <Popup>End Location</Popup>
                </Marker>
              </Map>
            </CardBody>
          </Card>
        ) : (
          <div className="text-center">No route found</div>
        )}
      </div>
    </PermittedComponent>
  )
}

export default LocationTracking
